import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, HostListener, Inject, ViewChild } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SafePipe } from '@siza-staff-care/shared/pipes';
import { ConfirmDialogModel } from './generic-dialogs.model';

@Component({
	template: `
		<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
			<h1 mat-dialog-title cdkDragHandle>{{ title }}</h1>
		</div>

		<div mat-dialog-content>
			<p [innerHtml]="message | safe"></p>
		</div>

		<div mat-dialog-actions align="end">
			<button [color]="confirmColor" (click)="onConfirm()" mat-stroked-button>
				{{ yesCaption }}
			</button>
			<button #noButton [color]="cancelColor" (click)="onDismiss()" mat-stroked-button>
				{{ noCaption }}
			</button>
			@if (hasCancel) {
				<button [color]="cancelColor" (click)="onCancel()" mat-stroked-button>Cancel</button>
			}
		</div>
	`,
	styles: [
		`
			@import 'theme-variables';

			::ng-deep {
				.mat-mdc-dialog-content {
					.warning {
						color: $warn;
					}
				}
			}
		`,
	],
	standalone: true,
	imports: [
		CommonModule,
		MatDialogModule,
		MatButtonModule,
		SafePipe,
		DragDropModule,
		MatButtonModule,
		MatDialogModule,
		SafePipe,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements AfterViewInit {
	@ViewChild('noButton') noButton?: MatButton;

	title: string;
	message: string;

	yesCaption = 'Yes';
	noCaption = 'No';

	hasCancel = false;

	get confirmColor() {
		return this.data.confirmIsPrimaryColor ? 'primary' : 'warn';
	}

	get cancelColor() {
		return this.data.confirmIsPrimaryColor ? 'warn' : 'primary';
	}

	constructor(
		public dialogRef: MatDialogRef<ConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel,
	) {
		// Update view with given values
		this.title = data.title;
		this.message = data.message;

		switch (data.type) {
			case 'okCancel':
				this.yesCaption = 'OK';
				this.noCaption = 'Cancel';
				break;
			case 'yesNo':
				this.hasCancel = true;
				break;
		}

		if (data.customConfirmCaption) {
			this.yesCaption = data.customConfirmCaption;
			this.noCaption = 'Cancel';
		}
	}

	ngAfterViewInit() {
		this.noButton?.focus();
	}

	@HostListener('document:keydown.y')
	onConfirm(): void {
		// Close the dialog, return true
		this.dialogRef.close(true);
	}

	@HostListener('document:keydown.n')
	onDismiss(): void {
		// Close the dialog, return false
		this.dialogRef.close(false);
	}

	onCancel() {
		this.dialogRef.close(null);
	}
}
